var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "map-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4791",
    "data-name": "Rectangle 4791",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M9.193,10.273a7.38,7.38,0,0,0,1.589-4.208,4.717,4.717,0,0,0-9.434,0,7.38,7.38,0,0,0,1.589,4.208,16.7,16.7,0,0,0,2.91,3.035.328.328,0,0,0,.435,0A16.7,16.7,0,0,0,9.193,10.273ZM7.137,14.35c1.741-1.426,4.993-4.585,4.993-8.286A6.065,6.065,0,0,0,0,6.065c0,3.7,3.252,6.859,4.993,8.286A1.675,1.675,0,0,0,7.137,14.35Z",
    transform: "translate(5.936 4.631)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M2.7,1.348A1.348,1.348,0,1,0,4.043,2.7,1.348,1.348,0,0,0,2.7,1.348ZM0,2.7a2.7,2.7,0,1,1,2.7,2.7A2.7,2.7,0,0,1,0,2.7Z",
    transform: "translate(9.305 8)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMark);
export default __webpack_public_path__ + "static/media/mapMark.648bd326e080601cf546837d39a99218.svg";
export { ForwardRef as ReactComponent };